import UAParser from 'ua-parser-js'

export default function Settings (params) {
  let scriptElt
  let account
  let host
  if (params !== undefined) {
    // in case of integration within a zenmsg
    scriptElt = params.elt
    account = params.account
    host = params.host
  } else {
    scriptElt = document.querySelector('script[data-gb-service="zenbot"]')
    account = scriptElt.getAttribute('data-gb-account')
    host = scriptElt.getAttribute('data-gb-host')
  }
  const url = `zenchat/${account}/`

  scriptElt.insertAdjacentHTML(
    'afterend',
    '<div></div>')

  const elt = scriptElt.nextSibling

  const caller = () => {
    let caller = ''
    if (window.location.href.indexOf('gb-caller=') > -1) {
      caller = window.location.href.substring(
        window.location.href.indexOf('gb-caller=') + 10,
        window.location.href.indexOf('gb-caller=') + 20)
    }
    return caller
  }

  const keyword = () => {
    return scriptElt.getAttribute('data-gb-keyword')
  }

  const ua = () => {
    const MOBILE_DEVICES = ['mobile', 'tablet', 'wearable', 'embedded']
    const parser = new UAParser()
    const res = parser.getResult()
    const model = res.device.model || 'PC'
    const isMobile = MOBILE_DEVICES.indexOf(res.device.type) > -1

    return {
      browser: res.browser.name,
      model: model,
      device: `${model}/${res.os.name}`,
      language: window.navigator.language,
      isMobile: isMobile
    }
  }

  const windowUrl = () => {
    if (process.env.VUE_APP_WINDOW_URL === undefined) {
      return window.location.href
    }
    return process.env.VUE_APP_WINDOW_URL
  }

  const wsUrl = () => {
    const scheme = host.substr(0, host.indexOf('://'))
    const wsScheme = scheme === 'http' ? 'ws' : 'wss'
    const wsHost = host.substr(host.indexOf('://') + 3)
    const wsUrl = `${wsScheme}://${wsHost}/asgi/chats/guests/v1`
    return wsUrl
  }

  return {
    account: account,
    caller: caller(),
    elt: elt,
    host: host,
    keyword: keyword(),
    ua: ua(),
    url: url,
    windowUrl: windowUrl(),
    wsUrl: wsUrl()
  }
}
